import { createReducer, on } from '@ngrx/store';
import { setCommentUserDetails } from './comments.actions';
import type { CommentUser } from '@candyland/generic/tt-com-comments/models';

export const COMMENTS_FEATURE_KEY = 'commentUserDetails';

export interface CommentUserDetailsPartialState {
  readonly [COMMENTS_FEATURE_KEY]: CommentUser | null;
}

const initialState: CommentUser = null;

export const commentUserDetailsReducer = createReducer(
  initialState,
  on(setCommentUserDetails, (_state: CommentUser | null, commentUser) => commentUser)
);
